// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"778b1f97","501":"4ba2cb2c"}[chunkId] + ".chunk.js";
};